/**
 *
 * Accessibility Contrast Mode (Webseite mit hohem Kontrast)
 *
 * Accessibility Contrast Mode fügt eine Funktion für eine Kontrastreiche Darstellung der Webseite hinzu. Die
 * Eingabe wird im Cookie zwischengespeichert, bis der Benutzer den Browser/Session schliesst.
 *
 * Event: document.ready
 *
 * @param {string} selector - Selector für den Button
 * @param {string} selectorWrapper - Selector Wrapper für den Button
 * @return {undefined}
 *
 *
 **/
function nc_initAccessibilityContrastMode(selector) {
  var moduleLogger = LoggerManager.get('contrast-mode').setPrefix('Selector: ' + selector);
  moduleLogger.trace('INIT START');
  $(document).ready(function () {
    nc_accessibilityContrastMode(selector);
  });
  moduleLogger.info('INIT ENDE');
}

/**
 * @see nc_initAccessibilityContrastMode
 * @param selector {string}
 * @param selectorWrapper {string}
 */
function nc_accessibilityContrastMode(selector) {
  var moduleLogger = LoggerManager.get('contrast-mode').setPrefix('Selector: ' + selector);
  moduleLogger.trace('SCRIPT START');

  // Klick-Handler für den Button
  $(selector).click(function () {
    $("html").toggleClass("accessibility__contrast-mode");

    // aria-pressed Attribut setzen
    const isActive = $("html").hasClass("accessibility__contrast-mode");
    $(this).attr("aria-pressed", isActive);

    // Cookie setzen oder löschen
    if (isActive) {
      $.cookie("NC_Theme_ContrastMode", 1, {expires: 1, path: '/'});
    } else {
      $.cookie("NC_Theme_ContrastMode", null, {path: '/'});
    }
  });

  // Cookie-Wert prüfen und Zustand setzen
  function checkCookieValues() {
    const isActive = $.cookie('NC_Theme_ContrastMode') == 1;
    if (isActive) {
      $("html").addClass("accessibility__contrast-mode");
    }
    // aria-pressed initial setzen
    $(selector).attr("aria-pressed", isActive);
  }

  checkCookieValues();
  moduleLogger.info('SCRIPT ENDE');
}